import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BetaContext = createContext({
  betaMode: false,
  betaConfig: null,
  aiUsage: null,
  loading: true,
  refreshUsage: () => {}
});

export const useBeta = () => useContext(BetaContext);

export const BetaProvider = ({ children }) => {
  const [betaConfig, setBetaConfig] = useState(null);
  const [aiUsage, setAiUsage] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchBetaConfig = async () => {
    try {
      const response = await axios.get(`${API}/beta/config`);
      setBetaConfig(response.data);
    } catch (error) {
      console.error('Failed to fetch beta config:', error);
      setBetaConfig({ beta_mode: false });
    }
  };

  const fetchAiUsage = async () => {
    try {
      const response = await axios.get(`${API}/beta/usage`, { withCredentials: true });
      setAiUsage(response.data);
    } catch (error) {
      // User might not be logged in
      setAiUsage(null);
    }
  };

  const refreshUsage = () => {
    fetchAiUsage();
  };

  useEffect(() => {
    const init = async () => {
      await fetchBetaConfig();
      setLoading(false);
    };
    init();
  }, []);

  return (
    <BetaContext.Provider
      value={{
        betaMode: betaConfig?.beta_mode || false,
        betaConfig,
        aiUsage,
        loading,
        refreshUsage
      }}
    >
      {children}
    </BetaContext.Provider>
  );
};

export default BetaProvider;
